var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Row, Col } from 'reactstrap';
import Box from "./Box";
import { STATS_VIDEO_SVG, STATS_AUDIO_SVG, STATS_CALENDAR_SVG } from "../assets/index";
import Loader from "./Loader";
import { shallowEqual } from "../util/compare";
import { withToast } from "../HOC/Toast";
import { errorToString } from "..";
export default withToast(/** @class */ (function (_super) {
    __extends(StatsView, _super);
    function StatsView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            loading: true,
            audio: 0,
            video: 0,
            last_week: 0
        };
        return _this;
    }
    StatsView.prototype.componentDidMount = function () {
        this.load();
    };
    StatsView.prototype.componentDidUpdate = function (prevProps) {
        if (!shallowEqual(prevProps.apiFilter, this.props.apiFilter))
            this.load();
    };
    StatsView.prototype.load = function () {
        var _this = this;
        this.setState({ loading: true });
        this.props.apiFunc(this.props.apiFilter).then(function (st) {
            _this.setState(__assign(__assign({}, st), { loading: false }));
        }).catch(function (err) {
            errorToString(err).forEach(function (message) {
                _this.props.showToast('danger', message);
            }, function () {
                _this.load();
            });
        });
    };
    StatsView.prototype.render = function () {
        var _a = this.state, loading = _a.loading, video = _a.video, audio = _a.audio, last_week = _a.last_week;
        return (React.createElement(Box, { className: "stats-view " + this.props.className || '', style: this.props.style },
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement("img", { className: "video-img", src: STATS_VIDEO_SVG }),
                    React.createElement("div", { className: "text-container" }, "Video"),
                    React.createElement("div", { className: "stats-counter" },
                        loading && React.createElement(Loader, { size: 30 }),
                        !loading && video.toLocaleString(undefined, { maximumFractionDigits: 0 }))),
                React.createElement(Col, null,
                    React.createElement("img", { className: "audio-img", src: STATS_AUDIO_SVG }),
                    React.createElement("div", { className: "text-container" }, "Audio"),
                    React.createElement("div", { className: "stats-counter" },
                        loading && React.createElement(Loader, { size: 30 }),
                        !loading && audio.toLocaleString(undefined, { maximumFractionDigits: 0 }))),
                React.createElement(Col, null,
                    React.createElement("img", { className: "this-week-img", src: STATS_CALENDAR_SVG }),
                    React.createElement("div", { className: "text-container" }, "This Week"),
                    React.createElement("div", { className: "stats-counter" },
                        loading && React.createElement(Loader, { size: 30 }),
                        !loading && last_week.toLocaleString(undefined, { maximumFractionDigits: 0 }))))));
    };
    return StatsView;
}(React.Component)));
//# sourceMappingURL=StatsView.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/StatsView.js
// module id = 1295
// module chunks = 0